import { render } from "./IconDonationsTotal.vue?vue&type=template&id=62da561c"
import script from "./IconDonationsTotal.vue?vue&type=script&lang=js"
export * from "./IconDonationsTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__